import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import SCALogo from '~/assets/images/logo.png';
import AbastekLogo from '~/assets/images/logoabastek.png';
import { Progress } from '~/components';
import api from '~/services/api';

import { Wrapper, WrapperLog, Logo } from './styles';

export default function AuthLayout({ children }) {
  const loading = useSelector((state) => state.auth.loading);
  const websiteJSON = JSON.parse(sessionStorage.getItem('web'));

  // console.log('websiteJSON', websiteJSON);
  const website = useMemo(
    () => ({
      logo: SCALogo,
      site_name: 'SCA+ Abastek',
    }),
    []
  );

  useEffect(async () => {
    await fetch('config.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.URL_BACKEND.length > 0) {
          api.defaults.baseURL = data.URL_BACKEND;
          sessionStorage.setItem('URL_BACKEND', data.URL_BACKEND);
          sessionStorage.setItem('URL_REPORT', data.URL_REPORT);
        } else {
          api.defaults.baseURL = process.env.REACT_APP_URL_REQUEST;
          sessionStorage.setItem(
            'URL_BACKEND',
            process.env.REACT_APP_URL_REQUEST
          );
          sessionStorage.setItem(
            'URL_REPORT',
            process.env.REACT_APP_URL_DOWNLOAD
          );
        }
      })
      .catch((err) => {
        console.info(err);
      });
  }, []);

  return (
    <Wrapper>
      <Progress loading={loading} />
      <WrapperLog>
        <img
          src={
            websiteJSON && websiteJSON.logo ? websiteJSON.logo : website.logo
          }
          alt={
            websiteJSON && websiteJSON.site_name
              ? websiteJSON.site_name
              : website.site_name
          }
        />
        {children}
        <Logo>
          {websiteJSON && !isEmpty(websiteJSON.site_name) ? (
            ''
          ) : (
            <img
              src={AbastekLogo}
              alt="Logo Abastek com escrita em preto com o t laranja"
            />
          )}
        </Logo>
        <Typography class="versao">
          versão:{' '}
          {new Date(process.env.REACT_APP_TIMESTAMP_BUILD * 1000)
            .toISOString()
            .slice(0, 16)
            .replace('T', '.')
            .replace(':', '')
            .replace('-', '')
            .replace('-', '')}{' '}
          build: {process.env.REACT_APP_COMMIT} tag: {process.env.REACT_APP_TAG}
        </Typography>
      </WrapperLog>
    </Wrapper>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
